import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { SystemAction } from 'store/system';
import { RequestStatus } from 'types/transport';
import { AuthAction } from './actions';

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(AuthAction.Clear, () => RequestStatus.None)
  .handleType(AuthAction.Error, () => RequestStatus.Error)
  .handleType(AuthAction.Request, () => RequestStatus.Creating)
  .handleType(AuthAction.Response, () => RequestStatus.Success)
  .handleType(AuthAction.Success, () => RequestStatus.None);

const successReducer = createReducer<boolean>(true)
  .handleType(AuthAction.Clear, () => false)
  .handleType(AuthAction.Success, () => true)
  .handleType(SystemAction.Unauthorized, () => false);

export default combineReducers({
  status: statusReducer,
  success: successReducer,
});
